module.exports = __webpack_public_path__ + "img/gieo-que1.9e993b61.png";